import { ACCESS_RIGHTS } from "@/constants/accessRights";

export var coreMenuItems = [
    { label: "SYSTEMS", isHeader: true },
    {
        id: "MainDashboard", label: "Dashboard", icon: "ri-bar-chart-2-fill",
        link: "/", click: function (e) { /* setIscurrentState injected */ },
    },

    { id: "Careers", label: "Careers", icon: "ri-printer-cloud-fill", link: "/socials/jobs", permissionTypeId: [] },

    { label: "Security", isHeader: true, permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_USERS, ACCESS_RIGHTS.CORE_SECURITY_ROLES, ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS, ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER, ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR, ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER] },
    { id: "Users", label: "Users", icon: "ri-admin-fill", link: "/security/users", permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_USERS] },
    { id: "Roles", label: "Roles", icon: "ri-lock-unlock-fill", link: "/security/roles", permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_ROLES] },
    { id: "AuditLogs", label: "Audit Logs", icon: "ri-shield-flash-fill", link: "/security/auditLogs", permissionTypeId: [ACCESS_RIGHTS.CORE_SECURITY_AUDITLOGS] },
    { id: "AccessRequests", label: "Access Requests", icon: "ri-key-fill", link: "/security/accessrequests", permissionTypeId: [ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER, ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR, ACCESS_RIGHTS.CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER] },

    { label: "Application", isHeader: true },
    { id: "FAQs", label: "FAQs", icon: "ri-question-fill", link: "/socials/faq" },
    { id: "PrivacyPolicy", label: "Privacy Policy", icon: "ri-git-repository-private-fill", link: "/socials/privacy-policy" },
    { id: "TermsCondition", label: "Terms Condition", icon: "ri-spam-2-fill", link: "/socials/terms-conditions" },

];